@if (volume) {
  <div class="container">
    <!------- Header ------->
    <div class="header"
      [ngClass]="(isExpanded$ | async) ? 'header-expanded' : 'header-collapsed'">
      <div class="header-left">
        <div [style.background-color]="volume.hexColor"
        class="volume-color-box"></div>
        <div class="info">
          <div class="title">{{volume.name}}</div>
          <div class="sub-title">{{volume.volume | number:'1.2-2'}} m3</div>
          <div class="sub-title">{{volume.center | wgs84}}</div>
        </div>
      </div>
      <div class="header-actions">
        @if (!(isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'expand' | transloco}}"
            (click)="onClickExpand()">expand_content
          </button>
        }
        @if ((isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'collapse' | transloco}}"
            (click)="onClickCollapse()">collapse_content
          </button>
        }
        <button mat-icon-button
          matTooltip="{{'close' | transloco}}"
          (click)="onClickClose()">close
        </button>
      </div>
    </div>

    <!------- Content ------->
    <div class="content"
      [ngClass]="(isExpanded$ | async) ? 'content-expanded' : 'content-collapsed'">
      <div class="main"
        [ngClass]="(isExpanded$ | async) ? 'main-expanded' : 'main-collapsed'">

        <!------- Viewer ------->
        @if ((viewerUrls$ | async); as viewerState){
          <ng-container>

            @if (viewerState.isLoading) {
              <div
                class="volume-viewer-state">
                Préparation des fichiers du volume…
              </div>
            }

            @if (!viewerState.isLoading && viewerState.lasUrl && viewerState.dxfUrl) {
              <div class="volume-viewer-wrapper">
                <volume-viewer
                  [class.volume-viewer-wrapper-collapsed]="!(isExpanded$ | async)"
                  [showToolbar]="!!(isExpanded$ | async)"
                  [options]="{showAxes: false}"
                  [sources]="{
                    lasUrl: viewerState.lasUrl,
                    dxfUrl: viewerState.dxfUrl
                  }"
                  [classificationDate1]="referenceBatchDate$ | async"
                  [classificationDate2]="currentBatchDate$ | async">>
                </volume-viewer>
              </div>
            }

            @if (!viewerState.isLoading && viewerState.error) {
              <div class="volume-viewer-state volume-viewer-state--error">
                Impossible de récupérer le fichier LAZ ou le fichier DXF.
              </div>
            }
          </ng-container>
        }


        <!------- Actions ------->
        <div class="actions">
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              matTooltip="{{'move_the_camera_on_the_volume' | transloco}}"
              (click)="onClickFlyTo(volume)">my_location
            </button>
          }
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              [matTooltip]="(volume.show ? 'hide_overlay' : 'show_overlay') | transloco"
              [disabled]="!(displayVolumes$ | async)"
              (click)="onClickToggleShow(volume)">
              <mat-icon>
                {{ volume.show ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          }
        </div>
      </div>
      <div class="side"
        [ngClass]="(isExpanded$ | async) ? 'side-expanded' : 'side-collapsed'">
        <!------- History ------->
        <volume-history-channel class="history"
        [itemId]="volume.id"></volume-history-channel>
      </div>
    </div>
  </div>
}
